/**
 * Faz 4 İP3/İP4 (DEV-3217 / DEV-3218) — canlı sorgu onayının ÜCRET DURUMU metni.
 *
 * NEDEN VAR: "Yenile" düğmesi sorguyu `forceFresh` ile koşuyor ve bu yol
 * `DosyaBorclu.kotaIslemleri()`nden GEÇMİYOR (kota kapısı `UyapRequest`te değil,
 * `DosyaBorclu.query*`te). O kapı, günün dosya hakkı dolmuşken varsayılan olarak
 * "Sorgu kotası kalmadı" diye durup BAKİYE HARCANMASINI engelliyor. Onay
 * diyaloğu aynı korumayı kullanıcıya devrediyor: hak durumu UYAP'a SORULUR
 * (plan ekranından farklı olarak burada UYAP oturumu var, tahmin gerekmez) ve
 * hak dolmuşsa kullanıcı bunu AÇIKÇA görerek onaylar.
 *
 * Mantık saf modülde: suite mount kullanmıyor (jest 26, saf modül deseni).
 */

export type UcretDurumu = "bilinmiyor" | "hak-var" | "hak-dolu";

export interface UcretDurumuOzeti {
    durum: UcretDurumu;
    /** Diyalogda gösterilecek açıklama. */
    metin: string;
    /** Onay düğmesinin rengi/metni bu bayrağa göre sertleşir. */
    ucretliOlabilir: boolean;
}

const BILINMIYOR: UcretDurumuOzeti = {
    durum: "bilinmiyor",
    metin:
        "Bu sorgu UYAP'tan yeniden çekilecek; dosya hakkı ya da sorgu bakiyesi " +
        "kullanılabilir. Hak durumu şu an sorulamadı.",
    ucretliOlabilir: true,
};

/** TL biçimi — bakiye metninde nokta/virgül karışmasın. */
function tl(deger: number): string {
    return deger.toFixed(2).replace(".", ",") + " TL";
}

/**
 * `SorguBakiyesi` cevabını kullanıcıya gösterilecek özete indirger.
 *
 * Cevap alınamadıysa (null/şekil tanınmadı) BİLİNMİYOR döner ve uyarı en
 * temkinli hâlinde kalır — belirsizlikte "ücretsiz" denmez.
 */
export function ucretDurumuOzetle(bakiye: any): UcretDurumuOzeti {
    if (!bakiye || typeof bakiye !== "object") {
        return BILINMIYOR;
    }

    const kalan = Number(bakiye.sorguKalanIslemSayisi);
    if (!Number.isFinite(kalan)) {
        return BILINMIYOR;
    }

    if (kalan > 0) {
        return {
            durum: "hak-var",
            metin:
                "Bu dosya için günlük ücretsiz sorgu hakkı mevcut (" + kalan +
                " dosya hakkı kaldı). Bu dosyada bugün ilk kez ücretli sorgu " +
                "yapılıyorsa günün hakkından bir dosya düşer, ek ücret alınmaz.",
            ucretliOlabilir: false,
        };
    }

    // `Number(null)` 0'dır ve sonlu görünür; eksik bakiyeyi "0,00 TL" diye
    // göstermek kullanıcıyı yanıltırdı — önce varlık denetlenir.
    const ham = bakiye.sorguBakiye;
    const tutar = ham === null || ham === undefined || ham === "" ? NaN : Number(ham);
    const bakiyeMetni = Number.isFinite(tutar) ? " Mevcut sorgu bakiyeniz: " + tl(tutar) + "." : "";

    return {
        durum: "hak-dolu",
        metin:
            "Günlük dosya hakkınız DOLU. Devam ederseniz sorgu ücreti " +
            "bakiyenizden düşebilir." + bakiyeMetni,
        ucretliOlabilir: true,
    };
}
